import emojiList from '../emojiPicker/config'

/**
 * 图片转base64
 * @param {string} 图片地址
 * @returns
 */
export const imageUrlToBase64 = imageUrl => {
  return new Promise((resolve, reject) => {
    const image = new Image()
    image.setAttribute('crossOrigin', 'Anonymous')
    image.src = imageUrl
    image.onload = function () {
      const canvas = document.createElement('canvas')
      canvas.width = image.width
      canvas.height = image.height
      const context = canvas.getContext('2d')
      context.drawImage(image, 0, 0, image.width, image.height)
      const base64Str = canvas.toDataURL('image/png')
      resolve(base64Str)
    }
    image.onerror = function (e) {
      reject(e)
    }
  })
}

/**
 * 转换base64
 * @param {string} base64
 * @returns
 */
export function parseBase64(base64) {
  const re = new RegExp('data:(?<type>.*?);base64,(?<data>.*)')
  const res = re.exec(base64)
  if (res) {
    return {
      type: res.groups.type,
      ext: res.groups.type.split('/').slice(-1)[0],
      data: res.groups.data
    }
  }
}

/**
 * 复制文字
 * @param {string} text  要复制的文本
 * @returns {boolean} true/false
 */
export const copyText = async text => {
  if (navigator && navigator.clipboard) {
    await navigator.clipboard.writeText(text)
    return true
  }
  // 动态创建 textarea 标签
  const textarea = document.createElement('textarea')
  // 将该 textarea 设为 readonly 防止 iOS 下自动唤起键盘，同时将 textarea 移出可视区域
  textarea.readOnly = 'readonly'
  textarea.style.position = 'absolute'
  textarea.style.left = '-9999px'
  textarea.style.opacity = '0'
  // 将要 copy 的值赋给 textarea 标签的 value 属性
  textarea.value = text
  // 将 textarea 插入到 body 中
  document.body.appendChild(textarea)
  // 选中值并复制
  textarea.select()
  const result = document.execCommand('Copy')
  document.body.removeChild(textarea)
  return result
}

/**
 * 复制图片
 * @param {string} imageUrl 图片地址
 * @param {boolean} isBase64 是否是base64
 */
export const copyImage = async (imageUrl, isBase64 = false) => {
  let base64Url = ''
  if (!isBase64) {
    base64Url = await imageUrlToBase64(imageUrl)
  } else base64Url = imageUrl
  const parsedBase64 = parseBase64(base64Url)
  const type = parsedBase64.type
  //将base64转为Blob类型
  const bytes = atob(parsedBase64.data)
  const ab = new ArrayBuffer(bytes.length)
  const ua = new Uint8Array(ab)
  for (let i = 0; i < bytes.length; i++) {
    ua[i] = bytes.charCodeAt(i)
  }
  const blob = new Blob([ab], { type })
  // eslint-disable-next-line no-undef
  navigator.clipboard.write([new ClipboardItem({ [type]: blob })])
}
// 判断是不是 emoji 表情包
export const isEmoji = src => {
  const is = emojiList.some(emoji => emoji.iconPath === src)
  return is
}
// 生成唯一的ID
export const onlyID = () => {
  var timestamp = new Date().getTime() // 获取当前时间戳
  var randomNum = Math.floor(Math.random() * 1000) // 生成一个随机数
  var uniqueId = timestamp + '-' + randomNum // 将时间戳和随机数拼接成唯一ID
  return uniqueId
}
// 64图片转文件流
export function base64toFile(base64, filename = 'file') {
  const arr = base64.split(',')
  const mime = arr[0].match(/:(.*?);/)[1]
  const suffix = mime.split('/')[1]
  const bstr = atob(arr[1])
  let n = bstr.length
  const u8arr = new Uint8Array(n)
  while (n--) {
    u8arr[n] = bstr.charCodeAt(n)
  }
  return new File([u8arr], `${filename}.${suffix}`, { type: mime })
}
